
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      id="home" 
      className="min-h-screen flex items-center justify-center relative bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://public.readdy.ai/ai/img_res/29b5aeb7bb4266de3d5353bb4a312efc.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Professional <span className="text-yellow-500">Bollard Installation</span> in Essex
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            Telescopic, Fold Down &amp; Electric Bollards for Residential and Commercial Properties
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="bg-black/50 backdrop-blur-sm rounded-lg p-6 border border-yellow-500/20">
              <i className="ri-arrow-up-down-line text-yellow-500 text-3xl mb-3"></i>
              <h3 className="text-lg font-semibold mb-2">Telescopic Bollards</h3>
              <p className="text-gray-300 text-sm">Discreet underground installation with maximum protection</p>
            </div>
            <div className="bg-black/50 backdrop-blur-sm rounded-lg p-6 border border-yellow-500/20">
              <i className="ri-hammer-line text-yellow-500 text-3xl mb-3"></i>
              <h3 className="text-lg font-semibold mb-2">Fold Down Bollards</h3>
              <p className="text-gray-300 text-sm">Affordable option that bolts to existing drives</p>
            </div>
            <div className="bg-black/50 backdrop-blur-sm rounded-lg p-6 border border-yellow-500/20">
              <i className="ri-flashlight-line text-yellow-500 text-3xl mb-3"></i>
              <h3 className="text-lg font-semibold mb-2">Electric Bollards</h3>
              <p className="text-gray-300 text-sm">Luxury automated protection for premium properties</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+447834858178" className="bg-yellow-500 text-black px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer">
              Get Free Quote
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a href="#services" className="border-2 border-yellow-500 text-yellow-500 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-500 hover:text-black transition-colors whitespace-nowrap cursor-pointer">
              View Our Work
              <i className="ri-eye-line ml-2"></i>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
